import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function BundeslaenderAvailability() {
  const [showList, setShowList] = useState(false);

  const states = [
	{ name: "Baden-Württemberg", status: "🟡", note: "Nicht flächenddeckend in ganz Baden-Württemberg" },
    { name: "Bayern", status: "🟢", note: "" },
	{ name: "Berlin", status: "🟢", note: "" },
    { name: "Brandenburg", status:  "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar"   },
    { name: "Bremen", status: "🟢", note: "" },
    { name: "Hamburg", status: "🟢", note: "" },
    { name: "Hessen", status:  "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar"  },
	{ name: "Mecklenburg-Vorpommern", status: "🟢", note: "" },
    { name: "Niedersachsen", status: "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar"  },
    { name: "Nordrhein-Westfalen (NRW)", status: "🟢", note: "" },
	{ name: "Rheinland-Pfalz", status: "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar" },
	{ name: "Saarland", status: "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar" },
    { name: "Sachsen", status: "🟢", note: "" },
	{ name: "Sachsen-Anhalt", status: "🔴", note: "Keine Tiefen-Wärmeleitfähigkeit abrufbar" },
    { name: "Schleswig-Holstein", status: "🟢", note: "" },
	{ name: "Thüringen", status: "🟢", note: "" },
  ];

  return (
    <div
      style={{
        background: "#f9f9f9",
        borderRadius: "12px",
        padding: "1.5rem",
        marginTop: "2rem",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <button
        onClick={() => setShowList(!showList)}
        style={{
          background: "#d44",
          color: "white",
          border: "none",
          borderRadius: "8px",
          padding: "0.7rem 1.2rem",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          cursor: "pointer",
        }}
      >
        {showList ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        Verfügbarkeit nach Bundesland anzeigen
      </button>

      {showList && (
        <table
          style={{
            width: "100%",
            marginTop: "1rem",
            borderCollapse: "collapse",
            fontSize: "0.95rem",
          }}
        >
          <thead>
            <tr style={{ textAlign: "left", borderBottom: "2px solid #ddd" }}>
              <th>Bundesland</th>
              <th>Status</th>
              <th>Hinweis</th>
            </tr>
          </thead>
          <tbody>
            {states.map((s, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "0.5rem 0.2rem" }}>{s.name}</td>
                <td style={{ padding: "0.5rem" }}>{s.status}</td>
                <td style={{ color: "#555" }}>{s.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

